import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchSuggestion = ({
  suggestion,
  onClick
}) => {
  const {
    t
  } = useTranslation();
  const didYouMean = t('search.didYouMean');
  return /*#__PURE__*/_jsx(Fragment, {
    children: !!suggestion && /*#__PURE__*/_jsxs(PlayContainer, {
      width: "small",
      children: [/*#__PURE__*/_jsx(SuggestionText, {
        children: `${didYouMean}: `
      }), /*#__PURE__*/_jsx(Suggestion, {
        "aria-label": `${didYouMean} ${suggestion}`,
        onClick: onClick,
        children: suggestion
      })]
    })
  });
};
const Suggestion = styled.button.withConfig({
  displayName: "SearchSuggestion__Suggestion",
  componentId: "sc-1abc6le-0"
})(["", ";text-transform:none;color:", ";padding:16px 0;"], Fonts.regular(18), Colors.GREY_d2d2d2);
const SuggestionText = styled.span.withConfig({
  displayName: "SearchSuggestion__SuggestionText",
  componentId: "sc-1abc6le-1"
})(["", ";color:", ";padding:16px 0;"], Fonts.regular(18), Colors.GREY_969696);